module.exports = __webpack_public_path__ + "media/images/leadership_characteristics/bg-1-9b198e46cbb047ad03328858230db4ab.png";